import { Box, Grid, List, useTheme } from "@mui/material";
import ScoreTypeButton from "components/listItems/ScoreTypeButton/ScoreTypeButton";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import React from "react";
import { scoreTypeBtns } from "utils/constants";

function ScoreTypesList() {
  const mainTheme = useTheme();

  return (
    <Box component="section">
      <CenteredColumnGrid container>
        <Grid item>
          <Box>
            <List
              sx={{
                padding: "10px",
                margin: "10px",
                borderRadius: "1.25rem",
                backgroundColor: mainTheme.palette.darkGraySecondary.main,
              }}
            >
              {scoreTypeBtns.map((btn) => (
                <ScoreTypeButton key={btn.id} btn={btn} />
              ))}
            </List>
          </Box>
        </Grid>
      </CenteredColumnGrid>
    </Box>
  );
}

export default ScoreTypesList;
